<template>
  <div
    :id="id"
    class="tile aspect a1-1"
    @mouseleave="pauseVideo"
    @mouseenter="playVideo"
  >
    <div v-if="videoId" class="back">
      <youtube
        :video-id="videoId"
        :ref="videoId"
        :player-vars="playerVars"
        @ready="handleReady"
        @playing="handlePlaying"
      ></youtube>
    </div>
    <div
      v-for="bg in background"
      :key="bg.id"
      class="back bg-image"
      :class="{ reveal: videoId }"
      :style="bg.src ? {} : { background: bg.background }"
    >
      <img
        v-if="bg.src && bg.parallax"
        :src="publicPath + bg.src"
        :alt="bg.alt"
        class="cover back rellax parallax"
        data-rellax-speed="0.5"
      />
      <img
        v-else-if="bg.src"
        :src="publicPath + bg.src"
        :alt="bg.alt"
        class="cover back"
      />
    </div>
    <slot name="background"></slot>
    <div v-if="links" class="refs right">
      <a
        v-for="link in links"
        :key="link.id"
        :title="link.title"
        :href="link.url"
        target="_blank"
        class="ref"
      >
        {{ link.name }}
        <!-- <span>{{ link.name }}</span> -->
        <ion-icon name="open" v-pre>Link</ion-icon>
      </a>
    </div>
    <div
      class="content bottom"
      :class="{ 'content-reveal': videoId, mask: mask }"
    >
      <hr v-if="title" class="baseline" />
      <h3 class="title" v-html="title" />
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/base.scss';

.tile {
  display: block;
  width: 100%;

  .back {
    width: 100%;
    height: 100%;

    video,
    iframe {
      width: 100%;
      height: 100%;
      padding: 0;
    }
  }

  .refs {
    position: absolute;
    right: 0;
    top: 0;
    transition: background-color 0.3s;
    padding: $baseline $baseline $baseline $line-height;
  }

  .reveal {
    opacity: 1;
    transition: opacity 0.3s;
  }

  .awaitplay {
    transition: all 0.3s;
  }

  &:hover,
  &:focus {
    .reveal {
      pointer-events: none;
      transition: opacity 0.3s;
      opacity: 0;
    }

    .refs {
      background: $primary-color;
      transition: background-color 0.3s;

      a {
        color: $text-dark;
        transition: color 0.3s;
      }
    }
  }

  .bg-image {
    overflow: hidden;

    img.parallax {
      width: 150%;
      height: 150%;
      top: 0;
      left: -25%;
    }
  }

  .content {
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: $baseline;

    * {
      position: relative;
    }
  }

  &:hover .content-reveal,
  &:focus .content-reveal {
    pointer-events: none;
  }

  hr.baseline {
    width: 25%;
    top: $line-height * 2;
    left: -$line-height;
    background: $primary-color;
  }
}

a.ref {
  height: $line-height;
  display: block;
  font-weight: 500;
  transition: color 0.3s;
  text-decoration-color: $text-dark;

  ion-icon {
    display: inline-block;
    height: $line-height;
    display: inline-flex;
    vertical-align: top;
  }
}
</style>

<script>
export default {
  name: 'Tile',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      playStarted: false
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    background: {
      type: Array,
      default: () => {
        return []
      }
    },
    videoId: {
      type: String,
      default: null
    },
    playerVars: {
      type: Object,
      default: () => {
        return {
          autoplay: 0,
          allowfullscreen: 1,
          frameborder: 0,
          startSeconds: 0
        }
      }
    },
    alt: {
      type: String,
      default: 'Background Thumbnail'
    },
    title: {
      type: String,
      default: ''
    },
    links: {
      type: Array,
      default: null
    },
    mask: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    player() {
      return this.$props.videoId ? this.$refs[this.$props.videoId].player : null
    }
  },
  methods: {
    playVideo() {
      if (this.player) this.player.playVideo()
    },
    pauseVideo() {
      if (this.player) this.player.pauseVideo()
    },
    handleReady() {
      // mute video
      if (this.player) this.player.mute()
    },
    handlePlaying() {
      if (!this.playStarted) {
        // first time playing
        document
          .querySelectorAll(
            '#' + this.id + ' .awaitplay, #' + this.id + '.awaitplay'
          )
          .forEach(el => {
            el.classList.add(el.getAttribute('data-play'))
          })

        // change play start flag
        this.playStarted = true
      }
    }
  }
}
</script>
